import { ChangeEvent } from 'react';
import SearchInput from '@/creditflowresearch/ui/common/components/molecules/SearchInput';
import { TileHeader } from '@creditflowresearch/uilib/Tile';
import Title from '@creditflowresearch/uilib/Title';
import Flex from '@creditflowresearch/uilib/Flex';
import Button from '@creditflowresearch/uilib/Button';
import { Link } from '@framework/router/Next/Link';
import { useStatsTileContext } from '@/creditflowresearch/application/ArticlesAndStats/Stats/StatsTile/StatsTileContext';
import { getTrimmedString } from '@/creditflowresearch/ui/common/helpers/getTrimmedString';
import { useGetLinkToAllStats } from './useGetLinkToAllStats';

import styles from './statsTile.module.scss';

const StatsTileHeader = () => {
  const {
    search,
    setSearch,
    statsData: { debouncedSearch },
  } = useStatsTileContext();

  const statsLink = useGetLinkToAllStats();

  const onSearchChange = ({ target: { value } }: ChangeEvent<HTMLInputElement>): void => {
    setSearch(value);
    const filteredValue = getTrimmedString(value);

    if (filteredValue === null) return;

    debouncedSearch(filteredValue);
  };

  return (
    <TileHeader
      title={ <Title title="Stats" /> }
      dataTest="statsTileHeader"
    >
      <Flex
        direction={ { sm: 'column-reverse', md: 'column-reverse', xl: 'row' } }
        align={ { sm: 'stretch', md: 'stretch', xl: 'center' } }
        gap={ 10 }
      >
        <SearchInput
          onChange={ onSearchChange }
          value={ search }
          placeholder="Filter by Name or Description"
          formFieldClassName={ styles.searchInputField }
          className={ styles.search }
        />
        <Button
          as={ Link }
          to={ statsLink }
          variant="outline"
          size="S"
          dataTest="statsTileAllStatsButton"
          ariaLabel="View all Stats"
        >
          All Stats
        </Button>
      </Flex>
    </TileHeader>
  );
};

export default StatsTileHeader;
